import React from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Image,
  FormControl,
  Form,
  Alert,
  ProgressBar,
  Spinner
} from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Logo from "../../assets/img/hvezda.png";
import VARIANT from "../../componets/ENUMS/VARIANT";
import _props from "../../componets/_params";

class Login extends React.Component {
  state={
    changeNotCorrect: true,
    newPassConditions: 0,
    newPassConditionsVariant: "secondary",
    newPass: "",
    confirmNewPass: "",
    confirmNewPassConditions: 0,
    confirmNewPassConditionsVariant: "danger",
    email: "",
    password: "",
    icorrectLogin: true,
    alert:[]
  }

  changeNewPass = (e) => {
    let x = e.target.value;
    var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    if (x.length > 0) this.setState({newPass: x, newPassConditions: 20, newPassConditionsVariant: "danger"});
    if (x.length > 6) this.setState({newPass: x, newPassConditions: 40, newPassConditionsVariant: "warning"});
    if (x.length > 8) this.setState({newPass: x, newPassConditions: 60, newPassConditionsVariant: "info"});
    if (x.length > 8 && Array.from(x).some((c) => c === c.toUpperCase()) && Array.from(x).some((c) => c === c.toLowerCase())) this.setState({newPass: x, newPassConditions: 80, newPassConditionsVariant: "success"});
    if (x.length > 8 && Array.from(x).some((c) => c === c.toUpperCase()) && Array.from(x).some((c) => c === c.toLowerCase()) && format.test(x)) this.setState({newPass: x, newPassConditions: 100, newPassConditionsVariant: "success"});
  }

  changeConfirmNewPass = (e) => {
    let x = e.target.value;
    if (this.state.newPass == x) this.setState({confirmNewPass: x, confirmNewPassConditions: 100, confirmNewPassConditionsVariant: "success", changeNotCorrect: false});
    if (this.state.newPass != x && x.length > 0) this.setState({confirmNewPass: x, confirmNewPassConditions: 20, confirmNewPassConditionsVariant: "danger" , changeNotCorrect: true});
    this.setState({confirmNewPass: x})
  }

  changeInput = (e) => {
    this.setState({icorrectLogin: true})
    if (e.target.id == "email") this.setState({email: e.target.value})
    if (e.target.id == "password") this.setState({password: e.target.value})
    if (e.target.id == "password" && e.target.value.length > 7 && this.state.email.length > 4) this.setState({icorrectLogin: false})
    if (e.target.id == "email" && e.target.value.length > 4 && this.state.password.length > 7) this.setState({icorrectLogin: false})
  }

  ApiLogin = async () => {
    this.setState({ loading: true });
    const _res = await this.props._api({
      ...this.props,
      method: "post",
      data: this.props._encrypt(JSON.stringify({
        email: this.state.email,
        pass: this.state.password,
        dateRequest: new Date().toLocaleString()
      })),
      endpoint: "/api/Login/public/user",
      param: "",
    });

    this.setState({ loading: false });
    if (_res.status == 200) {
      localStorage.setItem("u",_res.data);
      this.props.setUser(JSON.parse(this.props._decrypt(_res.data)))
      this.props.setNavigate("/user/repair");
      if (process.env.REACT_APP_ENV_TYPE == "DEV") console.log(JSON.parse(this.props._decrypt(_res.data)))
    } else {
      this.setState({
        alert: [
          {
            type: "danger",
            text: "Přihlášení se nepovedlo. Neplatné heslo nebo Email neexistuje.",
          },
        ],
      });
    }
  }

  changeConfirmPass = async () => {
    this.setState({ loading: true });
    const _res = await this.props._api({
      ...this.props,
      method: "post",
      data: this.props._encrypt(JSON.stringify({
        guid: this.props.params.id,
        pass: this.state.newPass,
      })),
      endpoint: "/api/Login/public/user/register/confirm",
      param: "",
    });

    this.setState({ loading: false });
    if (_res.status == 200) {
      this.setState({ checkModal: true, guid: JSON.parse(this.props._decrypt(_res.data)).guid });
      if (process.env.REACT_APP_ENV_TYPE == "DEV") console.log(JSON.parse(this.props._decrypt(_res.data)))
    }
  }

  componentDidMount() {
    this.props.setHeaderPage({
      Icon: null,
      Title: null,
      SubTitle: null,
    });
  }

  render() {
    const {Bs,VARIANT} = this.props;
    return (
      <>
        <div className="c-login-center">
          <Card>
            <Card.Body>

              <Bs row>
                <Bs alert variant={VARIANT.WARNING}>
                  Omlouváme se, ale login je momentálně nedostupný
                </Bs>
              </Bs>

              <Row className="mb-4">
                <Col xs={12}>
                  <span className="h5">
                    {(this.props.ip.indexOf("192.168.") == -1 && !this.props.params.id) && (
                      <strong>Přihlásit se</strong>
                    )}
                    {(this.props.ip.indexOf("192.168.") == -1 && this.props.params.id) && (
                      <strong>Nové heslo</strong>
                    )}
                    {this.props.ip.indexOf("192.168.") > -1 && (
                      <strong>Interní služby</strong>
                    )}
                  </span>
                </Col>
              </Row>

              <Row>
                <Col xs={12}>
                  <Image
                    src={Logo}
                    className="c-login-logo c-login-squircle me-2"
                  />
                </Col>
              </Row>
              <Row className="mb-4">
                <Col xs={12}>
                  <span className="h5">
                    <strong>Britex</strong>
                  </span>
                </Col>
              </Row>
              {this.state.alert.length > 0 && (
                <Alert variant={this.state.alert[0].type}>
                  {this.state.alert[0].text}
                </Alert>
              )}
              {(this.props.ip.indexOf("192.168.") == -1 && !this.props.params.id) && (
                <>
                  <Row className="mb-4">
                    <Col xs={12}>
                      <FormControl id="email" type="text" disabled onChange={this.changeInput} />
                      <Form.Text>Email</Form.Text>
                    </Col>
                  </Row>

                  <Row className="mb-4">
                    <Col xs={12}>
                      <FormControl id="password" type="password" disabled onChange={this.changeInput} onKeyDown={(e) => {
                        if(e.key=="Enter") this.ApiLogin()
                        }}/>
                      <Form.Text>Heslo</Form.Text>
                    </Col>
                  </Row>

                  <Row className="mb-4">
                    <Col xs={12}>
                      <Button size="sm" variant="success" disabled={this.state.icorrectLogin || this.state.loading || true} onClick={this.ApiLogin}>
                        {this.state.loading && (
                          <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                        )}
                        {!this.state.loading && (
                          <>Přihlásit se</>
                        )}
                      </Button>
                    </Col>
                  </Row>

                  <Row className="mb-4">
                    <Col xs={12}>
                      <NavLink className={"nav-link"} to="/Register">
                        Nemám účet
                      </NavLink>
                    </Col>
                  </Row>
                </>
              )}
              {this.props.params.id && (
                <>
                <Row className="mb-2">
                    <Col xs={12}>
                      <Alert variant="success">
                        Aktivace účtu proběhla úspěšně.<br /> Nyní si vytvořte heslo k účtu
                      </Alert>
                    </Col>
                  </Row>
                  <Row className="mb-1">
                    <Col xs={12}>
                      <Alert variant="info">
                        Heslo musí obsahovat velké a malé<br /> písmena číslovky a speciální znak
                      </Alert>
                    </Col>
                  </Row>
                <Row className="mb-1">
                    <Col xs={12}>
                      <FormControl type="password" onChange={this.changeNewPass} value={this.state.newPass}/>
                      <ProgressBar variant={this.state.newPassConditionsVariant} now={this.state.newPassConditions} />
                      <Form.Text>Nové heslo</Form.Text>
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col xs={12}>
                      <FormControl type="password" onChange={this.changeConfirmNewPass} value={this.state.confirmNewPass} />
                      <ProgressBar variant={this.state.confirmNewPassConditionsVariant} now={this.state.confirmNewPassConditions} />
                      <Form.Text>Kontrola hesla</Form.Text>
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col xs={12}>
                      <Button variant="success" size="sm" disabled={this.state.changeNotCorrect} onClick={this.changeConfirmPass}>Změnit heslo</Button>
                    </Col>
                  </Row>
                </>
              )}
              {(this.props.ip.indexOf("192.168.") > -1 || this.props.ip.indexOf("::1") > -1) && (
                <>
                  <Row className="mb-4">
                    <Col xs={12}>
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() =>
                          window.location.replace(process.env.REACT_APP_OAUTH2)
                        }
                      >
                        <Image src={Logo} className="c-logo-transparent me-2" />
                        <strong className="me-2">OAuth2</strong>
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            </Card.Body>
          </Card>
        </div>
      </>
    );
  }
}

export default _props(Login);
